@use '../../common/colors.scss' as colors;
@use '../../common//vars.scss' as vars;

.payment-plan-container {
  width: 50%;
  margin: 0 auto;
}

@media screen and (max-width: vars.$tablet) {
  .payment-plan-container {
    width: 60%;
  }
}

@media screen and (max-width: vars.$mobile) {
  .payment-plan-container {
    width: 100%;
  }
}

.new-plan-info-wrapper,
.new-plan-info,
.new-plan-info-monthly-payment,
.new-plan-info-monthly-payment-amount,
.new-plan-details,
.new-plan-details-column {
  display: flex;
}

.new-plan-info-wrapper,
.new-plan-info-monthly-payment-amount,
.new-plan-details-column {
  flex-direction: column;
}

.new-plan-info-wrapper,
.new-plan-info {
  width: 100%;
}

.new-plan-info-monthly,
.new-plan-info-remaining-payments,
.new-plan-downpayment,
.new-plan-details {
  font-size: 14px;

  @media screen and (max-width: vars.$mobile) {
    font-size: 12px;
  }
}

.new-plan-info-wrapper {
  align-items: flex-start;
  border-radius: 16px;
  padding: 12px;
  margin-bottom: 12px;
  border: 1px solid colors.$light-grey;
  min-height: 143px;
  justify-content: space-around;

  &:hover {
    cursor: pointer;
  }
}

.new-plan-info {
  justify-content: space-between;
  margin-bottom: 8px;
}

.new-plan-info-monthly-payment-amount {
  margin-left: 8px;
  line-height: 18px;
}

.new-plan-info-monthly-payment-value {
  font-size: 18px;
  font-weight: 500;

  span {
    color: colors.$header;
  }

  @media screen and (max-width: vars.$mobile) {
    font-size: 16px;
  }
}

.new-plan-info-remaining-payments {
  padding: 4px 8px;
  border-radius: 3px;
  line-height: 14px;
  height: fit-content;
}

.new-plan-downpayment {
  font-weight: 500;
  line-height: 13.2px;
}

.new-plan-details {
  margin-top: 12px;
  line-height: 13.2px;
}

.new-plan-details-column {
  margin-right: 16px;

  & > :first-child {
    font-weight: 500;
    margin-bottom: 4px;
  }
}

.new-plan-details-value {
  padding: 2px 3px;
}

.new-plan-promo {
  margin: -13px 5px 15px -13px;
  font-size: 14px;
  border-radius: 16px 0;
  background-color: colors.$dark-teal;
  color: colors.$white;
  padding: 5px 3px;

  span {
    padding: 10px;
  }
}

.new-plan-subvented {
  background-color: #2462bc;
  border-radius: 4px;

  span {
    color: colors.$white;
  }
}

.new-plan-info-remaining-payments {
  border-radius: 16px;
  color: colors.$dark-teal;
  background-color: colors.$light-teal;
}

.new-plan-selected {
  border: 2px solid colors.$uplift-green;
  padding: 11px;
}

// Flexpay
:global(.flexpay) {
  .payment-plan-container {
    color: colors.$flexpay-body-text;
    max-width: 444px;
    width: 100%;
  }

  .new-plan-info-wrapper {
    border: 1px solid colors.$flexpay-border;
    border-radius: 8px;
  }

  .new-plan-selected {
    border: 2px solid colors.$flexpay-link;
  }

  .new-plan-info-monthly-payment-value span {
    color: colors.$flexpay-title;
  }

  .new-plan-subvented {
    background-color: colors.$flexpay-light-blue;

    span {
      color: colors.$flexpay-link;
    }
  }

  .new-plan-info-remaining-payments {
    background-color: #e3f1f7;
    color: colors.$flexpay-link;
  }

  .new-plan-info-remaining-payments {
    background-color: #e3f1f7;
    color: colors.$flexpay-link;
    border-radius: 4px;
  }

  .new-plan-details-column > :first-child {
    color: colors.$flexpay-title;
  }

  .new-plan-promo {
    margin: -12px 5px 15px -12px;
    border-radius: 4px 0 8px 0;
    background-color: colors.$flexpay-link;
    padding: 0;
  }

  .new-plan-promo {
    background-color: colors.$flexpay-link;
    color: colors.$white;
    padding: 0;
  }

  .offer-tag {
    position: relative;
    background-color: rgb(31, 99, 210);
    border-radius: 8px 0 8px 0;
    height: 24px;
    left: -19px;
    top: -13px;
    padding: 0 16px;

    .tag-text {
      color: white;
      font-size: 14px;
      font-weight: 500;
      line-height: 15.4px;
      text-align: left;
      vertical-align: middle;
    }

    &.ZERO_APR {
      width: 88px;
    }

    &.LOWEST_MONTHLY_PAYMENT {
      width: 206px;

      &.fr {
        width: 234px;
      }
    }

    &::before {
      content: '';
      background: linear-gradient(
        45deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0) 50%,
        rgba(0, 77, 153, 1) 50%,
        rgba(0, 77, 153, 1) 100%
      );
      width: 6px;
      height: 8px;
      position: absolute;
      left: 0;
      bottom: -8px;
    }
  }
}
